export default __webpack_public_path__ + "static/media/logo.a12fa2b1.jpg";